import React from "react";
import { ArrowRight, MapPin } from "lucide-react";

const avatars = [
  "/img/blog/avatar-1.svg",
  "/img/blog/avatar-2.svg",
  "/img/blog/avatar-3.svg",
  "/img/blog/avatar-4.svg",
];

export default function BlogHero() {
  return (
    <section className="w-full bg-[#F4F1FC] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 py-14 md:py-20 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* LEFT: TEXT */}
        <div className="text-center sm:text-left">
          <h1 className=" font-extrabold leading-[1.1] tracking-tight text-4xl sm:text-5xl lg:text-[60px] ">
            <span className="block  text-gray-900">Travel Stories,</span>
            <span className="block  text-[#7209B7]">Tips &amp; Inspiration</span>
          </h1>

          <p className="mt-5 text-gray-500 text-base sm:text-[16px] leading-relaxed ">
            Explore real travel stories, expert tips, and destination guides
            to make your solo journey unforgettable.
          </p>

          <div className="mt-7 flex flex-col sm:flex-row items-center gap-3">
            <div className="flex -space-x-3">
              {avatars.map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt="Solo traveler"
                  className="w-10 h-10 rounded-full border-2 border-white object-cover bg-slate-200"
                />
              ))}
            </div>
            <p className="text-[14px] text-gray-600 max-w-[320px] leading-snug">
              Join 2,640+ solo travelers learning and exploring together.
            </p>
          </div>

          <a
            href="/write-blog"
            className="mt-8 inline-flex items-center gap-2 bg-[#7209B7] text-white font-semibold text-[15px] px-10 py-3 rounded-full hover:bg-[#5a07a0] active:scale-95 transition-all duration-200"
          >
            Write a Blog <ArrowRight className="w-4 h-4" />
          </a>
        </div>

        {/* RIGHT: IMAGE */}
        <div className="relative">
          <div className="rounded-[20px] overflow-hidden aspect-[4/3] bg-slate-200">
            <img
              src="/img/blog/hero-main.svg"
              alt="Solo traveler overlooking the coast"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Floating card */}
          <div className="absolute inset-x-0 mx-auto -bottom-12 sm:inset-x-auto sm:-left-28 sm:mx-0 sm:bottom-8 bg-white rounded-2xl shadow-xl p-4 flex items-center gap-3 max-w-[280px]">
            <span className="flex items-center justify-center w-9 h-9 rounded-full bg-purple-100 text-[#7209B7] shrink-0">
              <MapPin className="w-4 h-4" />
            </span>
            <div>
              <p className="text-[13px] font-semibold text-[#7209B7] mb-0.5">
                Featured Destination
              </p>
              <p className="text-[14px] font-bold text-gray-900 leading-snug">
                10 breathtaking places you must visit in 2026
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
